var fixtoInit;

(function ($) {

	const selectors = {
		wrapper: '[data-fixto-wrap]',
		box: '[data-fixto]'
	}


	fixtoInit = function () {
		$(selectors.box).each((i, el) => {
			new Fixto(el);
		})
	}


	class Fixto {
		constructor(element) {
			this.box = element;
			this.wrapper = $(this.box).closest(selectors.wrapper).get(0);

			this.onMobile = $(this.box).attr('data-on-mobile') !== undefined;

			if ($(this.wrapper).length) {
				this.init();
				this.bind();
				$(window).trigger('scroll');
				$(window).trigger('resize');
			}

		}
		init() {

			const self = this;

			self.offTop = 0;
			if ($(this.box).attr('data-offset')) this.offTop += parseInt($(this.box).attr('data-offset'));

			this.args = {
				top: self.offTop,
				useNativeSticky: false,
				mind: ''
			}

			if ($(this.box).attr('data-mind')) this.args.mind += ',' + $(this.box).attr('data-mind');

			self.fixto = fixto.fixTo(this.box, this.wrapper, this.args);

		}

		bind() {
			$(window).on('scroll', this.onScroll.bind(this));
			$(window).on('resize', this.onResize.bind(this));
		}

		onResize() {
			if (this.onMobile) return;
			const self = this;
			if ($(window).width() < 600) {
				self.fixto.stop();
			}
			else {
				self.fixto.start();
			}
		}

		onScroll() {

			const self = this;

			const over_banner = !($(window).scrollTop() > $('.o-banner').outerHeight() - self.offTop - window.headerHeight);

			if (over_banner && $(self.box).hasClass('not-on-banner')) {
				$(self.box).removeClass('not-on-banner');
			}
			else if (!over_banner && !$(self.box).hasClass('not-on-banner')) {
				$(self.box).addClass('not-on-banner');

			}

		}

	}

})(jQuery);


export default fixtoInit;